<div class="w-full h-[60px] flex items-center select-dropdown justify-between bg-white pl-4 pr-4 cursor-pointer" (click)="selectLanguage()">
  <div class="absolute top-0 mt-0.5 placeholder text-sm">{{placeholder | transloco}}</div>
  <div class="text-base capitalize">{{defaultLang?.toLowerCase() | transloco}}</div>
  <ion-icon name="chevron-down" class="text-2xl"></ion-icon>
</div>
